import * as React from 'react'
import { WithStyles, createStyles, Theme, withStyles } from '@material-ui/core'

const styles = (t: Theme) => createStyles({
    indexPanel: {
        position: "relative"
    },
    indexRedirect:{
        position: "absolute",
        top: 0, left: 0,
        width: "100%",
        height: "100%",
        zIndex: 999
    }
})

interface IProps extends WithStyles<typeof styles>{
    config: any;
    onClick?: () => void;
}

class IndexMiniChart extends React.PureComponent<IProps, {}>{
    _ref: any;

    constructor(props) {
        super(props);
        this._ref = React.createRef();
    }

    componentDidMount() {
        const { config } = this.props;
        const script = document.createElement('script');
        script.src = config.src
        script.async = true;
        script.innerHTML = JSON.stringify(config.script)
        document.getElementById(`mini-chart-${config.index}`).appendChild(script);
    }

    render() {
        const {config, classes, onClick} = this.props;
        return (
            <div 
                id={`mini-chart-${config.index}`} 
                className={classes.indexPanel}
                style={{width: "99.9%"}}
            > {/* 99.9 for fix border libs */}
                <div 
                    className={classes.indexRedirect} 
                    {...{onClick}}
                    {...onClick && {style: {cursor: "pointer"}}}
                >
                </div>
                <div className="tradingview-widget-container" ref={this._ref}>
                <div className="tradingview-widget-container__widget">
                    </div>
                </div>
            </div>
        )
    }
};

export default withStyles(styles)(IndexMiniChart);



// WEBPACK FOOTER //
// ./src/page/Consumer/MarketIndicators/IndexMiniChart.tsx